module.exports = __webpack_public_path__ + "img/fassadenreinigung.c4df764.png";